// src/services/templateService.ts
import api from './axios';
import { TemplateForm, TemplateType } from '@/components/template-builder-v3/types';
export const getTemplates = async (mode: TemplateType) => {
	const templateType = mode === TemplateType.CUSTOM ? TemplateType.CUSTOM : TemplateType.PAGE;
	const response = await api.get(`/template/list?type=${templateType}`);
	return response.data;
};

export const createTemplate = async (templateData: TemplateForm) => {
	const response = await api.post(`/template/create`, templateData);
	if (response.status === 201) {
		return { success: true, data: response.data.data };
	} else {
		return { success: false, message: response.data.message };
	}
};

export const updateTemplate = async (id: string, templateData: TemplateForm) => {
	const response = await api.put(`/template/update/${id}`, templateData);
	if (response.status === 200) {
		return { success: true, data: response.data.data };
	} else {
		return { success: false, message: response.data.message };
	}
};

export const deleteTemplate = async (id: string) => {
	const response = await api.delete(`/template/delete/${id}`);
	if (response.status === 200) {
		return { success: true, data: response.data.data };
	} else {
		return { success: false, message: response.data.message };
	}
};

export const checkImpact = async (id: string) => {
	const response = await api.get(`/template/check-impact/${id}`);
	if (response.status === 200) {
		return { success: true, data: response.data.data };
	} else {
		return { success: false, message: response.data.message };
	}
};

export const getTemplateById = async (id: string) => {
	const response = await api.get(`/template/get/${id}`);
	return response.data;
};

export const getContentLibrary = async () => {
	const response = await api.get(`/template/get-content-library`);
	if (response.status === 200) {
		return { success: true, data: response.data.data };
	} else {
		return { success: false, message: response.data.message };
	}
};

export const updateQuickAccess = async (pageKey: string) => {
	const response = await api.post(`/configuration/add-remove-quick-access`, {
		pageKey
	});
	if (response.status === 200) {
		return { success: true, data: response.data.message };
	} else {
		return { success: false, message: response.data.message };
	}
};
